import {h, Component} from 'preact';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import AsideMenuObjectStyles from "./AsideMenuObjectStyles";
import AsideMenuObjectLayouts from './AsideMenuObjectLayouts';
import React from "preact/compat";
import AsideMenuObjectNav from "./AsideMenuObjectNav";
import MenuObjectContent from "./MenuObjectContent";
import MenuObject from "../canvas/menu-object";
import AsideMenuObjectSpacing from "./AsideMenuObjectSpacing";
import AsideMenuObjectEdit from "./AsideMenuObjectEdit";
import AsideMenuObjectTop from "./AsideMenuObjectTop";
import AsideMONameBorder from './AsideMONameBorder';
import AsideMenuObjectText from './AsideMenuObjectText';

export default @connect(reduce, actions)
class AsideMenuObject extends Component {
  constructor() {
    super()
  }

  update(type, key, value) {
    const menuObjects = this.props.$elements.filter(it => it.attr('data-component') === 'menu-object');
    if (menuObjects.length) {
      MenuObject.patchStyles(this.props.isMultiSelect ? menuObjects : this.props.$element, { type, key, value });
    }
  }

  getDefaultNameStyles(allStyles, newStyles = {}) {
    let stylesToInherit = ['color', 'font-family', 'font-size', 'line-height', 'font-weight', 'text-transform', 'text-decoration', 'font-style', 'text-align'];
    stylesToInherit.forEach((styleString) => {
        if (allStyles['name'][styleString]) {
            newStyles[styleString] = allStyles['name'][styleString];
            this.update('mo-name', styleString, allStyles['name'][styleString]);  
        }
    });
    return newStyles;
  }

  getDefaultNoteStyles(allStyles, newStyles = {}) {
    let stylesToInherit = ['color', 'font-family', 'font-size', 'line-height', 'font-weight', 'text-transform', 'text-decoration', 'font-style', 'text-align'];
    stylesToInherit.forEach((styleString) => {
        if (allStyles['name'][styleString]) {
            newStyles[styleString] = allStyles['description'][styleString];
            this.update('mo-notes', styleString, allStyles['description'][styleString]);  
        }
    });
    return newStyles;
  }

  closeModal() {
    $('.aside-mo-top .bar').trigger('click');
  }

  deleteNameOrNote() {
    if (this.props.MOEditMode === 'name') {
      MenuObject.deleteMOName(this.props.$element);
      this.closeModal();
    } else if (this.props.MOEditMode === 'notes') {
      MenuObject.deleteMONotes(this.props.$element);
      this.closeModal();
    }
  }

  render(props, state) {
    let nameNoteStyles = {...props.menuObjectStyles};
    if (props.$element && props.menuObjectStyles.name){ // there are styles for selected mo
      if (!nameNoteStyles['mo-name']) {
        nameNoteStyles['mo-name'] = this.getDefaultNameStyles(props.menuObjectStyles);
      } else if (!nameNoteStyles['mo-name']['font-family']) {
        nameNoteStyles['mo-name'] = this.getDefaultNameStyles(props.menuObjectStyles, nameNoteStyles['mo-name']);
      }
      if (!nameNoteStyles['mo-notes']) {
        nameNoteStyles['mo-notes'] = this.getDefaultNoteStyles(props.menuObjectStyles);
      } else if (!nameNoteStyles['mo-notes']['font-family']) {
        nameNoteStyles['mo-notes'] = this.getDefaultNoteStyles(props.menuObjectStyles, nameNoteStyles['mo-notes']);
      }
    }

    const scrollerPosition = this.props.$element && this.props.isMobileVersion ? "bottom: 0;" : ""

    const isMOSelected = this.props.$element && MenuObject.isMenuObject(this.props.$element);
    const showNav = this.props.isMobileVersion && props.view === 'text-mo-edit' ? false : true;
    const showTop = isMOSelected && this.props.isMobileVersion && props.view !== 'text-mo-options';

    return (
      <div id="app-aside-text" className="aside-menu-object">
        <div style={scrollerPosition}>
          {showTop && <AsideMenuObjectTop/>}
          {showNav && <AsideMenuObjectNav view={props.view} isMobileVersion={props.isMobileVersion} MOEditMode={props.MOEditMode} />}
          {props.isMobileVersion && props.view === 'text-mo-edit' && isMOSelected && <AsideMenuObjectEdit 
            $element={props.$element}
            uploadedIcons={props.uploadedIcons}
            setUploadedIcons={props.setUploadedIcons}
          />}
          {props.view === "text-mo-style" && <AsideMenuObjectStyles nameNoteStyles={nameNoteStyles} />}
          {props.view === "text-mo-layout" && <AsideMenuObjectLayouts />}
          {props.view === "text-mo-spacing" && <AsideMenuObjectSpacing />}
          {props.view === "text-mo-name-border" && <AsideMONameBorder $element={props.$element} />}
          {!props.isMobileVersion && (props.view === 'text-mo' || props.view === 'text-mo-edit') && props.subview === 'add-new' &&
          <AsideMenuObjectText isPlainText={false} />}
          {!props.isMobileVersion && props.view === 'text-plain' &&
          <AsideMenuObjectText isPlainText={true} />}
          {props.isMobileVersion && ((props.view === 'text-mo' && props.subview === 'add-new') || props.view === 'text-plain') && 
          <AsideMenuObjectText isPlainText={false} />}
        </div>
      </div>
    )
  }
}
